<template>

  <div>
    <el-steps :active="0" finish-status="success">
      <el-step title="经办人认证"></el-step>
      <el-step title="备案信息录入"></el-step>
      <el-step title="付款"></el-step>
    </el-steps>

    <div class="single-apply-area">
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          label-position="left"
          v-loading="loading"
      >
        <el-form-item label="经办人信息" style="background-color: #fafafa" class="mt20"/>

        <el-form-item prop="operatorIdCardFront" label="经办人身份证正面" class="input-item">
          <el-input style="display: none" v-model="ruleForm.operatorIdCardFront"></el-input>
          <el-upload
              ref="operatorIdCardFront"
              class="avatar-uploader"
              :limit="1"
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 5)"
              :on-change="onChangeFront"
              action="/"
              accept="image/*"
          >
            <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                 @click.stop="changeUpload('operatorIdCardFront')">
              <img class="image-card" v-if="imageUrlOperatorFront" :src="imageUrlOperatorFront" alt/>
              <img
                  class="icon-check"
                  v-if="imageUrlOperatorFront"
                  @click.stop="checkImage('operatorFront')"
                  src="@/assets/login/icon-check-img.png"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="operatorIdCardBack" label="经办人身份证反面" class="input-item">
          <el-input style="display: none" v-model="ruleForm.operatorIdCardBack"></el-input>
          <el-upload
              class="avatar-uploader"
              :limit="1"
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 6)"
              :on-change="onChangeReserve"
              action="/"
              accept="image/*"
          >
            <div class="flex-dir-center-center" style="width: 100%;height: 100%">
              <img class="image-card" v-if="imageUrlOperatorReserve" :src="imageUrlOperatorReserve" alt/>
              <img
                  class="icon-check"
                  v-if="imageUrlOperatorReserve"
                  @click.stop="checkImage('operatorReserve')"
                  src="@/assets/login/icon-check-img.png"
                  alt
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item prop="operatorName" label="经办人姓名" class="input-item">
          <el-input
              v-model="ruleForm.operatorName"
              placeholder="请输入经办人姓名"
          ></el-input>
        </el-form-item>

        <el-form-item prop="operatorId" label="经办人身份证号" class="input-item">
          <el-input
              v-model="ruleForm.operatorId"
              placeholder="请输入经办人身份证号"
          ></el-input>
        </el-form-item>

        <el-form-item prop="operatorPhone" label="手机号码" class="input-item">
          <el-input
              type="number"
              v-model="ruleForm.operatorPhone"
              :maxlength="11"
              placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>

      </el-form>
    </div>

    <div class="bottom-box">
      <div style="color: #999;font-size: 12px !important;" class="flex-center-center mb10">
        <el-checkbox v-model="isAgree" class="mr10"></el-checkbox>
        <span class="pointer" @click="isAgree = !isAgree">我已阅读并同意</span>
        <span class="link" @click="privacy()">
            《隐私政策》
        </span>
      </div>
      <el-button type="primary" style="width: 40%" @click="goBack()">返回</el-button>
      <el-button type="primary" style="width: 40%" @click="submitForm()">去认证</el-button>
    </div>

    <privacy-dialog v-if="privacyVisible" :visible.sync="privacyVisible" :isAgree.sync="isAgree"/>
  </div>
</template>

<script>

import Cookies from "js-cookie";
import PrivacyDialog from "./components/privacyDialog.vue";

export default {
  name: "index",
  components: {PrivacyDialog},
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      isAgree: false,
      privacyVisible: false,
      loading: false,
      ruleForm: {},
      rules: {
        operatorIdCardFront: [
          {
            required: true,
            message: "请上传经办人身份证人像面照片",
            trigger: "change",
          },
        ],
        operatorIdCardBack: [
          {
            required: true,
            message: "请上传经办人身份证国徽面照片",
            trigger: "change",
          },
        ],
        operatorName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        operatorId: [{required: true, validator: validIdCard, trigger: "blur"}],
        operatorPhone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
      // 经办人身份证正面照片
      imageUrlOperatorFront: "",
      // 经办人身份证反面照片
      imageUrlOperatorReserve: "",
    }
  },
  methods: {
    privacy() {
      this.privacyVisible = true
    },

    goBack() {
      this.$router.go(-1);
    },

    createApply() {
      this.loading = true
      this.$http.post(this.$api.H5.createApply, JSON.stringify(this.ruleForm)).then(res => {
        if (res.data.code == 200) {
          window.location.href = res.data.data.faceCertifyUrl
          Cookies.set('PhysicalSeal', res.data.data.credential)
          this.loading = false
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },

    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          if (this.isAgree) {
            this.createApply()
          } else {
            const h = this.$createElement;
            this.$msgbox({
              title: '阅读并同意协议',
              customClass: 'message-box',
              message: h('p', undefined, [
                h('span', undefined, '我已阅读并同意'),
                h('span', {
                  style: 'color: #409EFF;cursor: pointer;',
                  on: {
                    click: () => {
                      this.privacy()
                    }
                  }
                }, '《隐私政策》')
              ]),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: '同意并继续',
              cancelButtonText: '取消',
              beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                  this.createApply()
                  this.isAgree = true;
                  done()
                } else {
                  done()
                }
              }
            }).then(action => {
            });
          }
        }
      })
    },

    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlReserve = e.target.result;
        } else if (type == 2) {
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          this.imageAuthorization = e.target.result;
        } else if (type == 4) {
          this.imageScene = e.target.result;
        } else if (type == 5) {
          this.imageUrlOperatorFront = e.target.result;
        } else if (type == 6) {
          this.imageUrlOperatorReserve = e.target.result;
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },

    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    changeUpload(e) {
      if (e == 'idCardFrontId' || e == 'businessLicenseId' || e == 'operatorIdCardFront') {
        if (typeof GSESC === 'object') {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      } else if (e == 'scene') {
        if (this.ruleForm.legalPersonName && this.ruleForm.legalPersonId) {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }
      // this.getEncryptStr()
    },

    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      } else if (flag == "operatorFront") {
        this.srcList.push(this.imageUrlOperatorFront);
      } else if (flag == "operatorReserve") {
        this.srcList.push(this.imageUrlOperatorReserve);
      } else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      } else if (flag == "auth") {
        this.srcList.push(this.imageAuthorization);
      } else {
        this.srcList.push(this.imageScene);
      }
      this.isShowPics = true;
    },

    request(base, type) {
      let params = {
        businessCode: this.ruleForm.orgCode ? this.ruleForm.orgCode : null,
        type: '' + type,
        imageBase64: base,
      };
      if (type == 5) {
        params.type = '0';
      } else if (type == 6) {
        params.type = '1';
      }
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "legalPersonName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "legalPersonId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "legalPersonIdCardFront", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "legalPersonIdCardBack", res.data.data.imageId);
          } else if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "orgName", res.data.data.businessName);
            }

            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "orgCode", res.data.data.businessCode);
              this.$refs.ruleForm.clearValidate()
            }
          } else if (type == 3) {
            this.$set(this.ruleForm, "authorisation", res.data.data.imageId);
          } else if (type == 4) {
            this.$set(this.ruleForm, "checkId", res.data.data.imageId);
          } else if (type == 5) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "operatorName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "operatorId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "operatorIdCardFront", res.data.data.imageId);
          } else if (type == 6) {
            this.$set(this.ruleForm, "operatorIdCardBack", res.data.data.imageId);
          }
          if (res.data.data.errMsg) {
            this.$message.warning(res.data.data.errMsg);
          } else {
            this.$message.success(res.data.msg);
          }
        } else {
          this.$message.error(res.data.msg);
          if (type == 0) {
            this.imageUrlFront = "";
          } else if (type == 1) {
            this.imageUrlReserve = "";
          } else if (type == 2) {
            this.imageLicenseId = "";
          } else if (type == 3) {
            this.imageAuthorization = "";
          } else if (type == 4) {
            this.imageScene = "";
          }
        }
        this.loading = false;
      });
    },
  }
}
</script>

<style>
.message-box {
  width: 90vw !important;
}
</style>

<style scoped lang="less">
.link {
  display: inline;
  color: #409EFF;
  cursor: pointer;
}

::v-deep .el-form-item {
  padding: 10px 20px;
  margin-bottom: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ebedf0;
  background-color: #ffffff;
}

.input-item {
  padding: 10px 20px 18px 20px !important;
}

.el-step {
  text-align: left;
}

.el-steps {
  padding: 10px 20px 0 20px;
  background-color: #FFFFFF;
}

.avatar-uploader {
  display: flex;
  justify-content: flex-end;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px
}

.bottom-box {
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  background-color: #FFFFFF;
  padding-top: 20px;
  z-index: 10;
}
</style>
